import { IExportColumnHeaders } from "@shared/interfaces/IExcelExport";
import { exportAlign } from "@fs/enums/export-align";
import { exportDataBound } from "@syncfusion/ej2-grids";

export class ExportColumnHeaders {

    public static get WorkOrderColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "PromisedDate", title: "Promised Date", style: { 'width': '50px' } },
            { field: "PromisedTime", title: "Promised Time" },
            { field: "WorkOrderNo", title: "Work Order No.", style: { 'width': '60px' } },
            { field: "PrimaryTechnician", title: "Technician" },
            { field: "StartTime", title: "Start Time" },
            { field: "CompletedDate", title: "Completed Date", style: { 'width': '50px' } },
            { field: "DisplayName", title: "Display Name" },
            { field: "Address", title: "Address", style: { 'width': '140px' } },
            { field: "TotalAmount", title: "Total Amount", cssClass: exportAlign.right },
            { field: "DepartmentName", title: "Department" },
            { field: "Priority", title: "Priority" },
            //{ field: "Status", title: "Status_SubStatus" },
            { field: "SubStatus", title: "State / Sub State" }
        ]
    }

    public static get WorkOrderReviewColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "CompletedDate", title: "Completed Date", style: { 'width': '50px' } },
            { field: "WorkOrderNo", title: "Work Order No.", style: { 'width': '60px' } },
            { field: "InvoiceDate", title: "Invoiced Date", style: { 'width': '50px' } },
            { field: "PrimaryTechnician", title: "Technician" },
            { field: "TotalAmount", title: "Total Amount", cssClass: exportAlign.right },
            { field: "BalanceDue", title: "Balance Due", cssClass: exportAlign.right },
            { field: "DepartmentName", title: "Department" },
            //{ field: "Status", title: "Status_SubStatus" },
            { field: "SubStatus", title: "State / Sub State" },
            { field: "DisplayName", title: "Site Display Name" },
            { field: "Address", title: "Site Address", style: { 'width': '140px' } }
        ]
    }

    public static get ProductColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "ItemNo", title: "Item No.", style: { 'width': '60px' } },
            { field: "Description", title: "Description", style: { 'min-width': '140px' } },
            { field: "Category", title: "Category", style: { 'width': '70px' } },
            { field: "StandardPrice", title: "Standard Price", cssClass: exportAlign.right, style: { 'width': '55px' } },
            { field: "BaseUOM", title: "Base UOM", style: { 'width': '40px' } },
            { field: "PreferredSupplier", title: "Preferred Supplier", style: { 'width': '60px' } },
            { field: "SupplierItem", title: "Supplier item No.", style: { 'width': '60px' } },
            { field: "Type", title: "Type", style: { 'width': '45px' } },
            { field: "ItemNote", title: "Item Note" },
        ];
    }

    public static get ProductColumnsForExcel(): Array<IExportColumnHeaders> {
        return [
            { field: "ItemNo", title: "Item No.", style: { 'width': '50px' } },
            { field: "Description", title: "Description", style: { 'min-width': '140px' } },
            { field: "Category", title: "Category", style: { 'width': '70px' } },
            { field: "FrequentlyUsed", title: "Frequently Used" },
            { field: "StandardPrice", title: "Standard Price", cssClass: exportAlign.right, style: { 'width': '70px' } },
            { field: "BaseUOM", title: "Base UOM", style: { 'width': '50px' } },
            { field: "PreferredSupplier", title: "Preferred Supplier", style: { 'width': '60px' } },
            { field: "SupplierItem", title: "Supplier item No.", style: { 'width': '60px' } },
            { field: "Type", title: "Type", style: { 'width': '60px' } },
            { field: "ItemNote", title: "Item Note", style: { 'width': '100px' } },
        ];
    }

    public static get ProductColumnsAllForExcel(): Array<IExportColumnHeaders> {
        return [
            { field: "Type", title: "Type", style: { 'width': '60px' } },
            { field: "ItemNo", title: "Item No.", style: { 'width': '50px' } },
            { field: "Description", title: "Description", style: { 'min-width': '140px' } },
            { field: "Category", title: "Category", style: { 'width': '70px' } },
            { field: "AccountingCode", title: "Accounting Code" },
            { field: "FrequentlyUsed", title: "Frequently Used" },
            { field: "ItemNote", title: "Item Note", style: { 'width': '100px' } },
            { field: "StandardPrice", title: "Standard Price", cssClass: exportAlign.right, style: { 'width': '70px' } },
            { field: "EstimatedPrice", title: "Estimated Cost" },
            { field: "IsPriceEditAllowed", title: "Allow Price Edit" },
            { field: "IsDescriptionEditAllowed", title: "Allow Description Edit" },
            { field: "IsDiscountExcluded", title: "Exclude from Discounts" },
            { field: "IsTaxable", title: "Item is Taxable" },
            { field: "IsSellable", title: "I sell this product to my customers" },
            { field: "BaseUOM", title: "Base UOM", style: { 'width': '50px' } },
            { field: "StandardCost", title: "Standard Cost" },
            { field: "Method", title: "Method" },
            { field: "LeadTime", title: "Lead Time Days" },
            { field: "Manufacturer", title: "Manufacturer" },
            { field: "ManufacturerPartNumber", title: "Manufacturer Part Number" },
            { field: "IsReturnable", title: "Returnable" },
            { field: "BlockedFromReordering", title: "Blocked From Reordering" },
        ];
    }

    public static get DiscountColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "Name", title: "Name" },
            { field: "DiscountType", title: "Discount Type", style: { 'width': '70px' } },
            { field: "Amount", title: "Amount", cssClass: exportAlign.right },
            { field: "MappingCode", title: "Accounting Integration" },
            { field: "IsAmountEditable", title: "Allow Edit Amount" },
            { field: "IsNameEditable", title: "Allow Edit Name" },
            { field: "IsActive", title: "Status", style: { 'width': '50px' } },
        ];
    }

    public static get ProductCategories(): Array<IExportColumnHeaders> {
        return [
            { field: "TradeName", title: "Trade" },
            { field: "CategoryName", title: "Category" },
            { field: "SubCategoryName", title: "Sub Category" }
        ];
    }

    public static get TaxMaintenanceColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "Name", title: "Name" },
            { field: "Description", title: "Description" },
            { field: "AccountingTaxCode", title: "Accounting Integration" },
            { field: "Status", title: "Status", style: { 'width': '50px' } }
        ];
    }

    public static get TaxMaintenanceColumnsForExcel(): Array<IExportColumnHeaders> {
        return [
            { field: "Name", title: "Name" },
            { field: "Description", title: "Description", style: { 'width': '150px' } },
            { field: "AccountingTaxCode", title: "Accounting Integration" },
            { field: "Status", title: "Status", style: { 'width': '50px' } },
            { field: "TaxRateName", title: "Tax Rate Name" },
            { field: "TaxRate", title: "Tax Rate", style: { 'width': '40px' } }
        ];
    }

    public static get PaymentTermsColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "Name", title: "Name" },
            { field: "Description", title: "Description" },
            { field: "Days", title: "Days", style: { 'width': '35px' } },
            { field: "MappingCode", title: "Accounting Integration" },
            { field: "IsActive", title: "Status", style: { 'width': '50px' } },
        ];
    }

    public static get PromisedTimeColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "Name", title: "Name", style: { 'min-width': '80px' } },
            { field: "Description", title: "Description" },
            { field: "BeginTime", title: "Begin Time[hrs : mins]", style: { 'width': '100px' } },
            { field: "BeginAMPM", title: "AM/PM", style: { 'width': '40px' } },
            { field: "EndTime", title: "End Time[hrs : mins]", style: { 'width': '100px' } },
            { field: "EndAMPM", title: "AM/PM", style: { 'width': '40px' } },
            { field: "IsActive", title: "Status", style: { 'width': '50px' } },
        ];
    }

    public static get EquimentWarrantyColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "Name", title: "Name", style: { 'min-width': '80px' } },
            { field: "Description", title: "Description" },
            { field: "DurationType", title: "Duration Type", style: { 'width': '100px' } },
            { field: "DurationValue", title: "Duration Value", style: { 'width': '40px' } },            
            { field: "IsActive", title: "Status", style: { 'width': '50px' } },
        ];
    }

    public static get CompanyCodeColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "Name", title: "Name" },
            { field: "Description", title: "Description" },
            { field: "IsActive", title: "Status", style: { 'width': '50px' } },
        ];
    }

    public static get AccountingCodeColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "Name", title: "Name" },
            { field: "Description", title: "Description" },
            { field: "MappingCode", title: "Accounting Integration" },
            { field: "IsActive", title: "Status", style: { 'width': '50px' } },
        ];
    }
    
    public static get CustManageColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "JobSiteDisplayName", title: "Job Site Display Name" },
            { field: "JobSiteAddress", title: "Job Site Address" },
            { field: "JobSiteType", title: "Job Site Type" },
            { field: "JobSiteContact", title: "Job Site Contact" },
            { field: "ContactPhone", title: "Contact Phone" },
            { field: "JobSiteStatus", title: "Job Site Status" },
            { field: "NextScheduledWorkOrder", title: "Next Scheduled Work Order" },
            { field: "CustomerDisplayName", title: "Customer Display Name" },
            { field: "CustomerAddress", title: "Customer Address" },
            { field: "CustomerType", title: "Customer Type" },
            { field: "CustomerStatus", title: "Customer Status" },
            { field: "JobSiteEmail", title: "Job Site Email" },
            { field: "JobSiteName", title: "Job Site Name" },
            { field: "CustomerContact", title: "Customer Contact" },
            { field: "CustomerPhoneNumber", title: "Customer Contact Phone" },
            { field: "CustomerEmail", title: "Customer Email" },
            { field: "CustomerName", title: "Customer Name" },
            { field: "TotalJobSiteCount", title: "Total Job Site Count" },
            { field: "JobSiteSince", title: "Job Site Since" },
            { field: "TaxCode", title: "Tax Code" },
            { field: "JobSiteAccountingIntegration", title: "Job Site Accounting Integration" },
            { field: "JobSiteComment", title: "Job Site Comment" },
            { field: "PaymentTerms", title: "Payment Terms" },
            { field: "CustomerAccountingIntegration", title: "Customer Accounting Integration" },
            { field: "CustomerComment", title: "Customer Comment" },
            { field: "CustomerSince", title: "Customer Since" }
        ];
    }

    public static get ServiceAgreementColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "AgreementNo", title: "Agreement No.", style: { 'width': '50px' } },
            { field: "AgreementName", title: "Agreement Name" },
            { field: "EffectiveDate", title: "Effective Date", style: { 'width': '60px' } },
            { field: "ExpirationDate", title: "Expiration Date" },
            { field: "Length", title: "Length" },
            { field: "Interval", title: "Interval", style: { 'width': '50px' } },
            { field: "JobSiteDisplayName", title: "Job Site Display Name" },
            { field: "Status", title: "Status", style: { 'width': '140px' } },
        ]
    }

    public static get VisitColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "AgreementNo", title: "Agreement No.", style: { 'width': '50px' } },
            { field: "JobSiteDisplayName", title: "Job Site Display Name" },
            { field: "JobSiteAddress", title: "Job Site Address" },
            { field: "FollowupDate", title: "Follow-Up Date", style: { 'width': '60px' } },
            { field: "ProposedDate", title: "Proposed Date" },
            { field: "Status", title: "Status" },
            { field: "AttemptCount", title: "No. of Attempts", style: { 'width': '50px' } },
            { field: "ContactNumber", title: "Contact Number", style: { 'width': '80px' } },
        ]
    }

    public static get EstimateColumns(): Array<IExportColumnHeaders> {
        return [
            { field: "EstimateNo", title: "Estimate No.", style: { 'width': '50px' } },
            { field: "Description", title: "Description", style: { 'wrapText':true } },
            { field: "JobSiteDisplayName", title: "Job Site Display Name" },
            { field: "JobSiteAddress", title: "Job Site Address" , style: {  'width': '200px' } },
            { field: "CreateDate", title: "Create Date", style: { 'width': '55px' } },
            { field: "ExpirationDate", title: "Expiration Date" , style: { 'width': '55px' } },
            { field: "Total", title: "Total"  , cssClass: exportAlign.right},
            { field: "Status", title: "State" },
            { field: "Technician", title: "Technician"  },
            { field: "Date", title: "Date" , style: { 'width': '55px' } },
            { field: "Time", title: "Time"  },
            { field: "AppointmentStatus", title: "Appointment State" },
        ]
    }
}